import { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/feature/Footer';
import Seo from '../../components/feature/Seo';

export default function HeroBanners() {
  const [selectedHero, setSelectedHero] = useState<number | null>(null);

  const heroes = [
    {
      id: 1,
      name: 'Hero 1: Centered Impact',
      description: 'Clean, centered design with strong value proposition'
    },
    {
      id: 2,
      name: 'Hero 2: Split Layout',
      description: 'Two-column design with visual storytelling'
    },
    {
      id: 3,
      name: 'Hero 3: Gradient Overlay',
      description: 'Full-width background with gradient overlay'
    },
    {
      id: 4,
      name: 'Hero 4: Card-Based',
      description: 'Modern card layout with key benefits'
    },
    {
      id: 5,
      name: 'Hero 5: Minimal Elegance',
      description: 'Sophisticated minimal design with focus on message'
    }
  ];

  return (
    <div className="min-h-screen bg-[#F8F6F3]">
      <Seo
        title="Hero Banner Vorschau (intern)"
        description="Interne Vorschau der Hero-Banner-Varianten."
        path="/hero-banners"
        noindex
      />
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1A2B3C] mb-4" style={{ fontFamily: 'Lora, serif' }}>
              Hero Banner Optionen
            </h1>
            <p className="text-lg text-[#4A5568] max-w-2xl mx-auto">
              Wählen Sie aus 5 verschiedenen Hero-Designs. Jedes fokussiert sich auf Ihr Angebot und die Vorteile für Ihre Kunden.
            </p>
          </div>

          <div className="space-y-20">
            {/* Hero 1: Centered Impact */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div className="p-6 border-b border-[#E5E7EB]">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-[#1A2B3C] mb-1">{heroes[0].name}</h3>
                    <p className="text-sm text-[#6B7280]">{heroes[0].description}</p>
                  </div>
                  <button
                    onClick={() => setSelectedHero(selectedHero === 1 ? null : 1)}
                    className="px-6 py-2 bg-[#8B1538] text-white rounded-full text-sm font-medium hover:bg-[#6B0F2A] transition-all cursor-pointer whitespace-nowrap"
                  >
                    {selectedHero === 1 ? 'Ausgewählt' : 'Auswählen'}
                  </button>
                </div>
              </div>
              <div className="relative h-[600px] bg-gradient-to-br from-[#1A2B3C] via-[#2C3E50] to-[#1A2B3C] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                  <div className="absolute top-20 left-20 w-64 h-64 bg-[#C9A961] rounded-full blur-3xl"></div>
                  <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#8B1538] rounded-full blur-3xl"></div>
                </div>
                <div className="relative z-10 text-center px-6 max-w-4xl">
                  <div className="inline-block px-4 py-2 bg-[#C9A961]/20 rounded-full mb-6">
                    <span className="text-[#C9A961] text-sm font-medium">Transformative Führungsentwicklung</span>
                  </div>
                  <h1 className="text-5xl md:text-7xl font-serif font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Lora, serif' }}>
                    Führen Sie mit<br />Klarheit & Authentizität
                  </h1>
                  <p className="text-xl text-[#E5E7EB] mb-10 max-w-2xl mx-auto leading-relaxed">
                    Entwickeln Sie eine Führungspräsenz, die inspiriert, Vertrauen schafft und nachhaltige Veränderungen bewirkt.
                  </p>
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <Link to="/kontakt" className="px-8 py-4 bg-[#8B1538] text-[#C9A961] rounded-full text-base font-medium hover:bg-[#6B0F2A] transition-all cursor-pointer whitespace-nowrap shadow-xl">
                      Erstgespräch vereinbaren
                    </Link>
                    <Link to="/ueber-mich" className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full text-base font-medium hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap border border-white/30">
                      Mehr erfahren
                    </Link>
                  </div>
                  <div className="mt-16 grid grid-cols-3 gap-8 max-w-3xl mx-auto">
                    <div className="text-center">
                      <div className="text-3xl font-bold text-[#C9A961] mb-2">15+</div>
                      <div className="text-sm text-[#E5E7EB]">Jahre Erfahrung</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-[#C9A961] mb-2">500+</div>
                      <div className="text-sm text-[#E5E7EB]">Führungskräfte begleitet</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-[#C9A961] mb-2">98%</div>
                      <div className="text-sm text-[#E5E7EB]">Zufriedenheitsrate</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Hero 2: Split Layout */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div className="p-6 border-b border-[#E5E7EB]">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-[#1A2B3C] mb-1">{heroes[1].name}</h3>
                    <p className="text-sm text-[#6B7280]">{heroes[1].description}</p>
                  </div>
                  <button
                    onClick={() => setSelectedHero(selectedHero === 2 ? null : 2)}
                    className="px-6 py-2 bg-[#8B1538] text-white rounded-full text-sm font-medium hover:bg-[#6B0F2A] transition-all cursor-pointer whitespace-nowrap"
                  >
                    {selectedHero === 2 ? 'Ausgewählt' : 'Auswählen'}
                  </button>
                </div>
              </div>
              <div className="grid md:grid-cols-2 h-[600px]">
                <div className="bg-[#1A2B3C] p-12 flex flex-col justify-center">
                  <div className="max-w-lg">
                    <div className="w-12 h-12 flex items-center justify-center mb-6">
                      <i className="ri-lightbulb-line text-4xl text-[#C9A961]"></i>
                    </div>
                    <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Lora, serif' }}>
                      Entdecken Sie Ihre innere Führungskraft
                    </h1>
                    <p className="text-lg text-[#E5E7EB] mb-8 leading-relaxed">
                      Durch bewusste Selbstreflexion und alchemistische Prinzipien entwickeln Sie eine authentische Führungspräsenz, die nachhaltig wirkt.
                    </p>
                    <div className="space-y-4 mb-10">
                      <div className="flex items-start gap-3">
                        <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                          <i className="ri-check-line text-xl text-[#C9A961]"></i>
                        </div>
                        <div>
                          <h4 className="text-white font-semibold mb-1">Klarheit in komplexen Situationen</h4>
                          <p className="text-sm text-[#E5E7EB]">Treffen Sie fundierte Entscheidungen mit Weitblick</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                          <i className="ri-check-line text-xl text-[#C9A961]"></i>
                        </div>
                        <div>
                          <h4 className="text-white font-semibold mb-1">Authentische Führungspräsenz</h4>
                          <p className="text-sm text-[#E5E7EB]">Entwickeln Sie einen inspirierenden Führungsstil</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                          <i className="ri-check-line text-xl text-[#C9A961]"></i>
                        </div>
                        <div>
                          <h4 className="text-white font-semibold mb-1">Nachhaltige Transformation</h4>
                          <p className="text-sm text-[#E5E7EB]">Schaffen Sie langfristige Veränderungen</p>
                        </div>
                      </div>
                    </div>
                    <Link to="/kontakt" className="inline-block px-8 py-4 bg-[#8B1538] text-[#C9A961] rounded-full text-base font-medium hover:bg-[#6B0F2A] transition-all cursor-pointer whitespace-nowrap">
                      Jetzt starten
                    </Link>
                  </div>
                </div>
                <div className="relative overflow-hidden">
                  <img
                    src="/images/hero/hero-banner-coaching.jpg"
                    alt="Coaching"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1A2B3C]/50 to-transparent"></div>
                </div>
              </div>
            </div>

            {/* Hero 3: Gradient Overlay */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div className="p-6 border-b border-[#E5E7EB]">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-[#1A2B3C] mb-1">{heroes[2].name}</h3>
                    <p className="text-sm text-[#6B7280]">{heroes[2].description}</p>
                  </div>
                  <button
                    onClick={() => setSelectedHero(selectedHero === 3 ? null : 3)}
                    className="px-6 py-2 bg-[#8B1538] text-white rounded-full text-sm font-medium hover:bg-[#6B0F2A] transition-all cursor-pointer whitespace-nowrap"
                  >
                    {selectedHero === 3 ? 'Ausgewählt' : 'Auswählen'}
                  </button>
                </div>
              </div>
              <div className="relative h-[600px] overflow-hidden">
                <img
                  src="/images/hero/hero-background-gradient.jpg"
                  alt="Background"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#1A2B3C]/80 via-[#1A2B3C]/70 to-[#8B1538]/60"></div>
                <div className="absolute inset-0 flex items-center justify-center px-6">
                  <div className="text-center max-w-4xl w-full">
                    <h1 className="text-5xl md:text-7xl font-serif font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Lora, serif' }}>
                      Transformieren Sie<br />Ihre Führungsqualität
                    </h1>
                    <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
                      Verbinden Sie alchemistische Weisheit mit modernem Leadership. Entwickeln Sie die Fähigkeit, Teams zu inspirieren und nachhaltige Erfolge zu schaffen.
                    </p>
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
                      <Link to="/kontakt" className="px-8 py-4 bg-white text-[#8B1538] rounded-full text-base font-medium hover:bg-[#F8F6F3] transition-all cursor-pointer whitespace-nowrap shadow-xl">
                        Kostenlose Beratung
                      </Link>
                      <Link to="/ueber-mich" className="px-8 py-4 bg-transparent text-white rounded-full text-base font-medium hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap border-2 border-white">
                        Mehr erfahren
                      </Link>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
                      <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                        <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                          <i className="ri-compass-3-line text-3xl text-[#C9A961]"></i>
                        </div>
                        <h4 className="text-white font-semibold mb-1">Orientierung</h4>
                        <p className="text-sm text-white/80">Klare Richtung finden</p>
                      </div>
                      <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                        <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                          <i className="ri-team-line text-3xl text-[#C9A961]"></i>
                        </div>
                        <h4 className="text-white font-semibold mb-1">Teamführung</h4>
                        <p className="text-sm text-white/80">Menschen bewegen</p>
                      </div>
                      <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                        <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                          <i className="ri-line-chart-line text-3xl text-[#C9A961]"></i>
                        </div>
                        <h4 className="text-white font-semibold mb-1">Wachstum</h4>
                        <p className="text-sm text-white/80">Kontinuierlich entwickeln</p>
                      </div>
                      <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                        <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                          <i className="ri-shield-check-line text-3xl text-[#C9A961]"></i>
                        </div>
                        <h4 className="text-white font-semibold mb-1">Resilienz</h4>
                        <p className="text-sm text-white/80">Stark in Krisen</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Hero 4: Card-Based */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div className="p-6 border-b border-[#E5E7EB]">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-[#1A2B3C] mb-1">{heroes[3].name}</h3>
                    <p className="text-sm text-[#6B7280]">{heroes[3].description}</p>
                  </div>
                  <button
                    onClick={() => setSelectedHero(selectedHero === 4 ? null : 4)}
                    className="px-6 py-2 bg-[#8B1538] text-white rounded-full text-sm font-medium hover:bg-[#6B0F2A] transition-all cursor-pointer whitespace-nowrap"
                  >
                    {selectedHero === 4 ? 'Ausgewählt' : 'Auswählen'}
                  </button>
                </div>
              </div>
              <div className="relative h-[600px] bg-gradient-to-br from-[#F8F6F3] to-[#E8E4DF] p-12 flex items-center justify-center">
                <div className="max-w-6xl w-full">
                  <div className="text-center mb-12">
                    <h1 className="text-4xl md:text-6xl font-serif font-bold text-[#1A2B3C] mb-4 leading-tight" style={{ fontFamily: 'Lora, serif' }}>
                      Ihr Weg zu bewusster Führung
                    </h1>
                    <p className="text-lg text-[#4A5568] max-w-2xl mx-auto">
                      Entdecken Sie die vier Säulen transformativer Führungsentwicklung
                    </p>
                  </div>
                  <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
                    <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all cursor-pointer group">
                      <div className="w-12 h-12 flex items-center justify-center bg-[#8B1538]/10 rounded-lg mb-4 group-hover:bg-[#8B1538] transition-all">
                        <i className="ri-mind-map text-2xl text-[#8B1538] group-hover:text-white transition-all"></i>
                      </div>
                      <h3 className="text-lg font-bold text-[#1A2B3C] mb-2">Selbstreflexion</h3>
                      <p className="text-sm text-[#6B7280] leading-relaxed">
                        Verstehen Sie Ihre inneren Muster und entwickeln Sie authentische Führungsqualitäten
                      </p>
                    </div>
                    <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all cursor-pointer group">
                      <div className="w-12 h-12 flex items-center justify-center bg-[#8B1538]/10 rounded-lg mb-4 group-hover:bg-[#8B1538] transition-all">
                        <i className="ri-user-heart-line text-2xl text-[#8B1538] group-hover:text-white transition-all"></i>
                      </div>
                      <h3 className="text-lg font-bold text-[#1A2B3C] mb-2">Empathie</h3>
                      <p className="text-sm text-[#6B7280] leading-relaxed">
                        Bauen Sie tiefe Verbindungen zu Ihrem Team und schaffen Sie Vertrauen
                      </p>
                    </div>
                    <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all cursor-pointer group">
                      <div className="w-12 h-12 flex items-center justify-center bg-[#8B1538]/10 rounded-lg mb-4 group-hover:bg-[#8B1538] transition-all">
                        <i className="ri-focus-3-line text-2xl text-[#8B1538] group-hover:text-white transition-all"></i>
                      </div>
                      <h3 className="text-lg font-bold text-[#1A2B3C] mb-2">Klarheit</h3>
                      <p className="text-sm text-[#6B7280] leading-relaxed">
                        Treffen Sie fundierte Entscheidungen mit Weitblick und Präzision
                      </p>
                    </div>
                    <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all cursor-pointer group">
                      <div className="w-12 h-12 flex items-center justify-center bg-[#8B1538]/10 rounded-lg mb-4 group-hover:bg-[#8B1538] transition-all">
                        <i className="ri-rocket-line text-2xl text-[#8B1538] group-hover:text-white transition-all"></i>
                      </div>
                      <h3 className="text-lg font-bold text-[#1A2B3C] mb-2">Umsetzung</h3>
                      <p className="text-sm text-[#6B7280] leading-relaxed">
                        Verwandeln Sie Erkenntnisse in konkrete, nachhaltige Handlungen
                      </p>
                    </div>
                  </div>
                  <div className="text-center">
                    <Link to="/kontakt" className="inline-block px-8 py-4 bg-[#8B1538] text-[#C9A961] rounded-full text-base font-medium hover:bg-[#6B0F2A] transition-all cursor-pointer whitespace-nowrap shadow-lg">
                      Ihre Reise beginnt hier
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Hero 5: Minimal Elegance */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div className="p-6 border-b border-[#E5E7EB]">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-[#1A2B3C] mb-1">{heroes[4].name}</h3>
                    <p className="text-sm text-[#6B7280]">{heroes[4].description}</p>
                  </div>
                  <button
                    onClick={() => setSelectedHero(selectedHero === 5 ? null : 5)}
                    className="px-6 py-2 bg-[#8B1538] text-white rounded-full text-sm font-medium hover:bg-[#6B0F2A] transition-all cursor-pointer whitespace-nowrap"
                  >
                    {selectedHero === 5 ? 'Ausgewählt' : 'Auswählen'}
                  </button>
                </div>
              </div>
              <div className="relative h-[600px] bg-white flex items-center justify-center px-6">
                <div className="max-w-4xl w-full">
                  <div className="text-center mb-12">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#F8F6F3] rounded-full mb-6">
                      <div className="w-2 h-2 bg-[#8B1538] rounded-full"></div>
                      <span className="text-sm font-medium text-[#1A2B3C]">Alchemistische Führungsentwicklung</span>
                    </div>
                    <h1 className="text-5xl md:text-7xl font-serif font-bold text-[#1A2B3C] mb-6 leading-tight" style={{ fontFamily: 'Lora, serif' }}>
                      Führung neu<br />gedacht
                    </h1>
                    <p className="text-xl text-[#4A5568] max-w-2xl mx-auto mb-10 leading-relaxed">
                      Entwickeln Sie eine Führungspräsenz, die auf Bewusstsein, Authentizität und nachhaltiger Transformation basiert.
                    </p>
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
                      <Link to="/kontakt" className="px-8 py-4 bg-[#1A2B3C] text-white rounded-full text-base font-medium hover:bg-[#2C3E50] transition-all cursor-pointer whitespace-nowrap">
                        Gespräch vereinbaren
                      </Link>
                      <Link to="/blog" className="px-8 py-4 bg-transparent text-[#1A2B3C] rounded-full text-base font-medium hover:bg-[#F8F6F3] transition-all cursor-pointer whitespace-nowrap border-2 border-[#1A2B3C]">
                        Blog lesen
                      </Link>
                    </div>
                    <div className="flex items-center justify-center gap-12 text-left">
                      <div>
                        <div className="text-4xl font-serif font-bold text-[#8B1538] mb-1" style={{ fontFamily: 'Lora, serif' }}>15+</div>
                        <div className="text-sm text-[#6B7280]">Jahre Expertise</div>
                      </div>
                      <div className="w-px h-12 bg-[#E5E7EB]"></div>
                      <div>
                        <div className="text-4xl font-serif font-bold text-[#8B1538] mb-1" style={{ fontFamily: 'Lora, serif' }}>500+</div>
                        <div className="text-sm text-[#6B7280]">Begleitete Führungskräfte</div>
                      </div>
                      <div className="w-px h-12 bg-[#E5E7EB]"></div>
                      <div>
                        <div className="text-4xl font-serif font-bold text-[#8B1538] mb-1" style={{ fontFamily: 'Lora, serif' }}>98%</div>
                        <div className="text-sm text-[#6B7280]">Weiterempfehlungsrate</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute top-10 right-10 w-32 h-32 bg-[#C9A961]/10 rounded-full blur-3xl"></div>
                <div className="absolute bottom-10 left-10 w-40 h-40 bg-[#8B1538]/10 rounded-full blur-3xl"></div>
              </div>
            </div>
          </div>

          {selectedHero && (
            <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-[#1A2B3C] text-white px-6 py-4 rounded-full shadow-2xl z-50">
              <div className="flex items-center gap-3">
                <i className="ri-check-line text-xl text-[#C9A961]"></i>
                <span className="font-medium">Hero {selectedHero} ausgewählt</span>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
